import { EditOutlined, StarOutlined } from '@mui/icons-material';
import { Box, CardHeader, IconButton, Stack, Typography } from '@mui/material';
import { OrgAvatarUploadButton } from 'components/ui/emblem/avatar-upload-button';
import { OrgEmblemBanner } from 'components/ui/emblem/emblem-banner';
import { OrganizationProfile } from 'middleware-types';
import { Permission } from 'utils/permissions';
import { useAssociateUser } from 'utils/useAssociateUser';
import { useSiteUser } from 'utils/useSiteUser';

/**
 * A read only view of the Org Profile Header
 */
export const OrgProfileHeaderRead = (props: {
	profile: OrganizationProfile;
	onBeginEdit: (initialFocusedField?: string) => void;
}) => {
	const { hasPermission: hasAssociateUserPermission } = useAssociateUser(props.profile.id);
	const { hasPermission: hasSiteUserPermission } = useSiteUser();
	const { profile } = props;
	const canEdit =
		hasAssociateUserPermission(Permission.Org_Profile_U) ||
		hasSiteUserPermission(Permission.Site_OrgProfile_U);

	return (
		<>
			<OrgEmblemBanner id={profile.id} enableUpload={canEdit} />
			<CardHeader
				className="z-20"
				avatar={<OrgAvatarUploadButton id={profile.id} disabled={!canEdit} />}
				title={<Typography variant="h2">{profile.displayName}</Typography>}
				subheader={
					<Stack spacing={0.5}>
						<Typography variant="subtitle2">
							<Stack direction="row" alignItems="flex-start" spacing={0.5}>
								<StarOutlined color="primary" fontSize="small" />
								<Box>
									Based in&nbsp;<strong>{profile.displayLocation}</strong>
								</Box>
							</Stack>
						</Typography>
					</Stack>
				}
				action={
					canEdit && (
						<IconButton onClick={() => props.onBeginEdit()}>
							<EditOutlined />
						</IconButton>
					)
				}
			/>
		</>
	);
};
